import type {GetServerSideProps} from 'next';
import type {GetServerSidePropsResult} from 'next/types';
import {isReleasedRedesignTop} from '../../../../config/unReleasePage';
import {
  type GetUserDataForAnalyticsResponseType,
  type UsersMeFollowedCompaniesResponseType,
  getUserDataForAnalytics,
  getUserFollowedCompanies,
} from '../../../../core/repositories/usersMeRepository';
import {FavsCompaniesPage} from '../../../../features/mypage/components/FavsCompaniesPage';
import {withHandler} from '../../../../server/token/withHandler';
import {ScriptForGA} from '../../../../shared/components/ScriptForGA';
import {NoLeftSidebarLayout} from '../../../../shared/components/layouts/NoLeftSidebarLayout';
import {StandardLayout} from '../../../../shared/components/layouts/StandardLayout';
import type {NextPageWithLayout} from '../../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
  userFollowedCompanies?: UsersMeFollowedCompaniesResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withRequiredSession'
>(
  {auth: 'required'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;
    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    const userFollowedCompaniesResponse = await getUserFollowedCompanies({
      cookies,
    });
    if (!userFollowedCompaniesResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
        userFollowedCompanies: userFollowedCompaniesResponse.value,
      },
    };
  },
);

const FavsCompanies: NextPageWithLayout<Props> = ({
  userDataForAnalytics,
  userFollowedCompanies,
}) => {
  return (
    <>
      <FavsCompaniesPage userFollowedCompanies={userFollowedCompanies} />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default FavsCompanies;

FavsCompanies.getLayout = (page) =>
  isReleasedRedesignTop() ? (
    <NoLeftSidebarLayout>{page}</NoLeftSidebarLayout>
  ) : (
    <StandardLayout>{page}</StandardLayout>
  );
